
import { Component, ElementRef, Input, OnInit, ViewChild, DoCheck } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog, MatSidenavModule, MatTooltipModule} from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { SelectionModel, DataSource } from '@angular/cdk/collections';
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { environment } from "environments/environment";
import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { stringify } from '@angular/compiler/src/util';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { EventEmitter } from 'events';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { stat } from 'fs';

export interface PeriodicElement {
  id: string;
  cuit: string;
  razon: string;
  contacto: string;
  responsable: string;
  deuda: string;
  cct: string;
  descripcion: string;
}

var ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.css']
})

export class EmpresasComponent implements OnInit {
  modaless: string = "modal-body";
  loading;
  loadingins;
  loadingInsert;
  displayedColumns: string[] = ['select','cuit', 'razon', 'contacto', 'responsable', 'cct', 'descripcion','x'];
  dataSourceOpe = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  selection = new SelectionModel<PeriodicElement>(true, []);
  fecha_hoy;
  fechad;//input fecha desde
  fechah;//input fecha hasta
  filtroCuit; //input cuit para filtrar
  filtroEstado; //input estado para filtrar
  pcuit; prazon; pcontacto; prespo; pcct; pidsec; pcalle; ppuerta; pcp; //para el body del post inserta nueva empresa
  pfecha;
  permitir: boolean = false;
  role;
  userlog;

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public snackBar: MatSnackBar
  ){ 
    this.loading=false;
    this.loadingins = false;
    this.loadingInsert = false;
    this.fecha_hoy = new Date;
    this.fecha_hoy = this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd");
    //this.fechah = this.fecha_hoy;
    this.filtroCuit = 'TODOS';
    this.filtroEstado = 'TODOS';
    this.pfecha = this.fecha_hoy;
    this.permitir = false;
    this.role=localStorage.getItem('role');
    this.userlog = localStorage.getItem('userId');
  }

  CambiarPermitir(){
    if (this.permitir == false){
      this.permitir = true;
    }else{
      this.permitir = false;
    }
  }

  ngOnInit() {
    console.log(this.fecha_hoy);
    this.fechad = '2010-01-01';
    this.fechah = this.fecha_hoy;
    this.calculaEmpresas();
    this.cargarGrid();
    this.calculaSeccionales();
    
  }
  obse=false;
  habilitaobs(){
    if (this.obse == false){
      this.obse = true;
    }else{
      this.obse = false;
    }
  }
  status = false;
  habilitaestado(){
    if (this.status == false){
      this.status = true;
    }else{
      this.status = false;
    }
  }

  item = [{}];
  modifobs;
  modifestado;
  modalessHeader:string = 'modal-header';
  modalessBody;
  cuitselected;

  mostrarsec = false;
  secselected;
  mostrarSec(){
    this.mostrarsec = !this.mostrarsec;
  }

  ngDoCheck(){
    if (this.selection.selected[0] != null ){
      this.item = [];
      this.item.push(this.selection.selected[0]);
      //this.cuitselected = this.selection.selected[0]["cuit"]
      //console.log(this.cuitselected);
      console.log(this.item);
      this.modifobs = this.item[0]["obs"];
      this.modifestado = this.item[0]["estado"];

      this.modicui = this.item[0]["cuit"];
      this.modirazon = this.item[0]["razon"];
      this.modicontac = this.item[0]["contacto"];
      this.modirespo = this.item[0]["responsable"];
      this.modicct = this.item[0]["cct"];
      this.modiidsec = this.item[0]["id_seccional"];

      var body = {
        "cui": this.modicui,
        "raz": this.modirazon,
        "conta": this.modicontac,
        "respo": this.modirespo,
        "cct": this.modicct,
        "idsec": this.modiidsec
      };




    }else{
      //console.log("no se selecciono nada");
    }
    //console.log(this.filtroCuit + '-' + this.filtroEstado + '-' + this.fechad + '-'+this.fechah);
  
  }

  clean(){
    this.selection.clear();
  }

  dataSourceSeccionales;
  calculaSeccionales(){
    this.loading=true;
      this.dataSourceSeccionales =  null;
      //http://localhost:1337/api/empresas/getseccionales
      this.http.get(`${environment.backendUrl}/api/empresas/getseccionales`)
      .subscribe((datos: any[]) => {
        if(datos){
          this.dataSourceSeccionales = datos;
          //console.log(this.dataSourceSeccionales);
        }else{
          console.warn("NO HAY seccionales");
        };
        this.loading=false;
      });
   
  }

  cargarGrid(){
    this.loading=true;
      this.dataSourceOpe.data =  null;
      //http://localhost:1337/api/empresas/get?cuit=TODOS
      this.http.get(`${environment.backendUrl}/api/empresas/get?cuit=TODOS`)
      .subscribe((datos: any[]) => {
        if(datos){
          this.dataSourceOpe.data = datos[0];
          //console.log(this.dataSourceOpe.data);
        }else{
          console.warn("NO HAY");
        };
        this.loading=false;
      });
  }
  
  codError='NO';
  formularionuevaempresa;
  borrarDatosEmpresa(){
    this.pcuit="";
    this.prazon="";
    this.pcontacto="";
    this.prespo="";
    this.pcct="";
    this.pidsec="";
    this.pcalle="";
    this.ppuerta="";
    this.pcp="";
  }

  errorEliminar = false;
  loadingEliminar = false;

  eliminarEmpresa(cui){
    this.loadingEliminar = true;
    var body = {
      "cui": `${cui}`
    };

    //http://localhost:1337/api/nuevaope/eliminaEmpresa
    this.http.post(`${environment.backendUrl}/api/nuevaope/eliminaEmpresa`, body)
    .subscribe(
      res => {
        console.log('---RES OK');
        console.log(res[0]["result"]);
        let resultado = res[0]["result"];
        if (resultado == 'OK'){
          console.log("borrado ok!");
          this.snackBar.open(`Empresa eliminada ${resultado}`, 'Cerrar', {duration: 5000});
          this.loadingEliminar = false;
          this.errorEliminar = false;
          document.getElementById("salirmodal").click();
          this.cargarGrid();
          this.calculaSeccionales();
        }
        if (resultado == 'NO_EXISTE'){
          console.log("No se elimina por que no existe en tabla de empresas");
          this.snackBar.open(`NO EXISTE!`, 'Cerrar', {duration: 5000});
          this.loadingEliminar = false;
          this.errorEliminar = false;
        }
        if (resultado == 'TIENE_OPERACIONES'){
          this.errorEliminar = true;
          console.log("no se puede eliminar por que tiene novedades asignadas");
          this.snackBar.open(`(NO SE ELIMINO) EMPRESA CON NOVEDADES ASIGNADAS!`, 'Cerrar', {duration: 5000});
          this.loadingEliminar = false;
        }
      },
      status => {
        if (status.status == 200){  
          //this.snackBar.open(`${JSON.stringify(status["result"])}`, 'Cerrar', {duration: 5000});
          //this.loadingEliminar=false;
          //document.getElementById("chaumodal").click();
          //this.cargarGrid();
        }
        if (status.status == 500){
          console.warn("ERROR POST!");
          console.log(JSON.stringify(status["error"]["code"]));
          this.codError = JSON.stringify(status["error"]["code"]);
          this.snackBar.open(`FALLO! ${JSON.stringify(status["error"]["code"])}`, 'Cerrar', {duration: 5000});
          this.loadingEliminar=false;
        }else{
          this.loadingEliminar=false;
        }
      }
    );
  
  }

 loadingUpdate = false;
 modicui;
 modirazon;
 modicontac;
 modirespo;
 modicct;
 modiidsec;


 updateEmpresa(i){
  
  this.loadingUpdate = true;
  var body;
  if (this.mostrarsec==true){
    body = {
      "cui": `${i}`,
      "razon": `${this.modirazon}`,
      "contac": `${this.modicontac}`,
      "respon": `${this.modirespo}`,
      "cct": `${this.modicct}`,
      "idse": `${this.secselected}`
    };
  }else{
    body = {
      "cui": `${i}`,
      "razon": `${this.modirazon}`,
      "contac": `${this.modicontac}`,
      "respon": `${this.modirespo}`,
      "cct": `${this.modicct}`,
      "idse": `${this.modiidsec}`
    };
  }
  console.log(body);
  
  //http://localhost:1337/api/nuevaope/updateEmpresa
  this.http.post(`${environment.backendUrl}/api/nuevaope/updateEmpresa`, body)
  .subscribe(
    res => console.log('---RES OK', res),
    status => {
      if (status.status == 200){
        console.warn("post OK!");   
        this.snackBar.open(`Empresa modificada ok!`, 'Cerrar', {duration: 5000});
        this.loadingUpdate=false;
        this.mostrarsec=false;
        this.cargarGrid();
        document.getElementById("byemodal").click();
      }
      if (status.status == 500){
        console.warn("ERROR POST!");
        console.log(JSON.stringify(status["error"]["code"]));
        this.snackBar.open(`FALLO! ${JSON.stringify(status["error"]["code"])}`, 'Cerrar', {duration: 5000});
        this.loadingUpdate=false;
      }else{
        this.loadingUpdate = false;
      }
    }
  );

 }


  insertaEmpresa(){
    this.codError='NO'
    this.loadingInsert = true;
    var body = {
      "cuit": `${this.pcuit}`,
      "razon": `${this.prazon}`,
      "contacto": `${this.pcontacto}`,
      "respo": `${this.prespo}`,
      "cct": `${this.pcct}`,
      "idsec": `${this.pidsec}`,
      "calle": `${this.pcalle || ''}`,
      "puerta": `${this.ppuerta || ''}`,
      "cp": `${this.pcp || ''}`
    };
    //http://localhost:1337/api/empresas/insertar
    this.http.post(`${environment.backendUrl}/api/empresas/insertar`, body)
    .subscribe(
      res => console.log('---RES OK', res),
      status => {
        if (status.status == 200){
          console.warn("post OK!");   
          this.snackBar.open(`Insertado OK!`, 'Cerrar', {duration: 5000});
          this.loadingInsert=false;
          this.borrarDatosEmpresa();
          document.getElementById("chaumodal").click();
          this.cargarGrid();
          this.codError = 'NO';
        }
        if (status.status == 500){
          console.warn("ERROR POST!");
          console.log(JSON.stringify(status["error"]["code"]));
          this.codError = JSON.stringify(status["error"]["code"]);
          this.snackBar.open(`FALLO! ${JSON.stringify(status["error"]["code"])}`, 'Cerrar', {duration: 5000});
          this.loadingInsert=false;
        }
      }
    );
  
  }

  dataSourceEmpresas;
  loadingemp;
  calculaEmpresas(){
    this.loadingemp=true;
    //http://localhost:1337/api/nuevaope/calculaemp
    this.http.get(`${environment.backendUrl}/api/nuevaope/calculaemp`)
    .subscribe((datos: any[]) => {
      if(datos){
        this.dataSourceEmpresas = datos[0];
        //console.log(this.dataSourceEmpresas);
      }else{
        console.warn("NO HAY");
      };
      this.loadingemp=false;
    });
  }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceOpe.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSourceOpe.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: PeriodicElement): string {
    this.clean();
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }


}
